import { Injectable } from '@angular/core';
import { HTTP_CONTENT_HEADERS } from 'src/app/shared/data/const.data';
import { MessageToastService } from './message-toast.service';
import { UtilityService } from './utility.service';
import { saveAs } from 'file-saver'; // Статический импорт

@Injectable({
  providedIn: 'root'
})
export class ExcelService {
  constructor(
    private _utils: UtilityService,
    private _msg: MessageToastService
  ) {}

  exportExcel(filename: string, items: any[], columns: string[] = [], names: string[] = []) {
    if (names.length == 0) names = [...columns];
    if (items.length == 0) {
      this._msg.warning('Пустая таблица');
      return;
    }
    import('xlsx').then(xlsx => {
      const data = this._utils.prepareArrayForTableWithNames(items, columns, names);
      const worksheet = xlsx.utils.json_to_sheet(data, { header: names });
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = HTTP_CONTENT_HEADERS.Excel;
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }
}
